import { observer } from 'mobx-react';
import * as React from 'react';
import FieldValidationErrorNotice from './FieldValidationErrorNotice';
import { noticeWithStores } from '../util/StoresProvider';
import { Separator } from 'telia-front-react';
import { useNoticeStores } from '../stores/NoticeRootStore';
const SharedFieldValidationErrorNotice = observer((props) => {
    const { fieldValidationStore } = useNoticeStores();
    const { erroredFields, addToErroredFields } = fieldValidationStore;
    React.useEffect(() => {
        var _a;
        (_a = props.additionalErroredFields) === null || _a === void 0 ? void 0 : _a.forEach((label, id) => addToErroredFields(id, label));
    }, []);
    return (React.createElement(React.Fragment, null,
        erroredFields.size !== 0 && props.topSeparatorSpacing && React.createElement(Separator, { spacing: props.topSeparatorSpacing, color: "invisible" }),
        React.createElement(FieldValidationErrorNotice, null),
        erroredFields.size !== 0 && props.bottomSeparatorSpacing && React.createElement(Separator, { spacing: props.bottomSeparatorSpacing, color: "invisible" })));
});
export default noticeWithStores(SharedFieldValidationErrorNotice);
//# sourceMappingURL=SharedFieldValidationErrorNotice.js.map